export type StructureCategory = 'professional' | 'scientific' | 'training'

export const STRUCTURE_CATEGORY = {
  PROFESSIONAL: 'professional',
  SCIENTIFIC: 'scientific',
  TRAINING: 'training',
} as const

export interface AdherentStructure {
  id: string
  acronym: string
  fullName: string
  category: StructureCategory
}
